import React from "react";

import { Link } from "@samskip/frontend-components";

import Logo from "@assets/images/samskip-logo.inline.svg";
import { CommonTypes, UserProfileViewModel } from "@assets/types";
import {
  constructMainServiceWebLink,
  setupMenu,
} from "@assets/utilities/navMenuUtilities";
import { Navigation, UserInfo, WebsitesMenu } from "@components";

type HeaderProps = {
  userProfile?: UserProfileViewModel;
  logout: CommonTypes.CallbackFunction;
  selectedMenu?: string;
};

const Header: React.FC<HeaderProps> = ({
  userProfile,
  logout,
  selectedMenu,
}) => {
  return (
    <header className="bg-neutral-0">
      <div className="w-full max-w-[1200px] mx-auto">
        <div className="flex flex-col justify-between">
          {/* Top */}
          <div className="flex flex-row justify-between pt-[0.625rem]">
            <WebsitesMenu />
            <UserInfo logout={logout} userProfile={userProfile} />
          </div>
          {/* Bottom */}
          <div className="flex flex-row justify-between items-start h-[62px]">
            <Link href={constructMainServiceWebLink("")}>
              <Logo className="w-64" />
            </Link>
            <Navigation
              menuItems={userProfile?.Menu && setupMenu(userProfile?.Menu)}
              selectedMenu={selectedMenu}
            />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
